export const STORAGE_KEYS = {
  USER_EMAIL: 'user_email',
  EDITIONS_CONTACT_FORM: 'editions_contact_form',
  ROI_CALCULATOR: 'roi_calculator',
};

export type StorageKey = keyof typeof STORAGE_KEYS;

function isBrowser() {
  return typeof window !== 'undefined';
}

export const store = (key: StorageKey, value: string) => {
  if (!isBrowser()) return null;
  sessionStorage.setItem(STORAGE_KEYS[key], value);
};

export const storeJSONInSession = (key: StorageKey, value: object) => {
  if (!isBrowser()) return null;
  try {
    sessionStorage.setItem(STORAGE_KEYS[key], JSON.stringify(value));
  } catch (error) {
    console.error('Failed to store JSON in sessionStorage:', error);
  }
};

export const retrieveJSONFromSession = (key: StorageKey) => {
  if (!isBrowser()) return null;
  try {
    const item = sessionStorage.getItem(STORAGE_KEYS[key]);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Failed to retrieve JSON from sessionStorage:', error);
    return null;
  }
};

export const retrieve = (key: StorageKey) => {
  if (!isBrowser()) return null;
  return sessionStorage.getItem(STORAGE_KEYS[key]);
};

export const remove = (key: StorageKey) => {
  if (!isBrowser()) return null;
  return sessionStorage.removeItem(STORAGE_KEYS[key]);
};
